export default function TableRemoveButtonDirective() {
  return {
    template: require('./table-remove-button.html'),
    transclude: true,
    restrict: 'AE',
    scope: {
      values: '=',
      index: '@'
    },
    controller: TableRemoveButtonController,
    controllerAs: 'vm',
    bindToController: true
  };
}

function TableRemoveButtonController(arrayUtil) {
  'ngInject';
  var vm = this;
  vm.remove = remove;

  function init() {
    vm.index = parseInt(vm.index);
  }

  function remove() {
    vm.values = arrayUtil.remove(vm.values, vm.index);
  }

  init();
}